// features/cashierAssistance/cashierSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchCashierTicketsThunk, updateCashierTicketThunk } from './cashierThunks';

const cashierSlice = createSlice({
  name: 'cashierTickets',
  initialState: { tickets: [], loading: false, error: null },
  reducers: {
    // Called from the notification WebSocket when a CASHIER_ASSISTANCE
    // notification arrives, so the list updates live without a refetch.
    ticketPushed(state, action) {
      const t = action.payload;
      const idx = state.tickets.findIndex((x) => x.id === t.id);
      if (idx >= 0) state.tickets[idx] = t;
      else state.tickets.unshift(t);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCashierTicketsThunk.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchCashierTicketsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.tickets = action.payload.results || action.payload;
      })
      .addCase(fetchCashierTicketsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to load tickets';
      })
      .addCase(updateCashierTicketThunk.fulfilled, (state, action) => {
        const idx = state.tickets.findIndex((t) => t.id === action.payload.id);
        if (idx >= 0) state.tickets[idx] = action.payload;
      });
  },
});

export const { ticketPushed } = cashierSlice.actions;
export default cashierSlice.reducer;
